import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { FuseAnimationCurves } from '@fuse/animations/defaults';

export const routeAnimations = trigger('routeAnimations', [
    transition('* <=> *', [
        // Initial styles for entering / leaving views
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
            }),
        ], { optional: true }),

        // Animate leave & enter simultaneously
        group([
            query(':leave', [
                animate(`200ms ${FuseAnimationCurves.acceleration}`, style({
                    opacity: 0,
                })),
            ], { optional: true }),

            query(':enter', [
                style({
                    opacity: 0,
                    transform: 'translateY(20px)',
                }),
                animate(`300ms 100ms ${FuseAnimationCurves.deceleration}`, style({
                    opacity: 1,
                    transform: 'translateY(0)',
                })),
            ], { optional: true }),
        ]),
    ]),
]);
